import {
  AfterViewInit,
  Directive,
  ElementRef,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[cleanStepPanelAccessibility]'
})
export class CleanStepPanelAccessibilityDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.cleanElementRecursively(this.el.nativeElement);
  }

  private cleanElementRecursively(element: HTMLElement): void {
    // Normalize tag name to uppercase for consistency
    const tag = element.tagName.toUpperCase();

    // 1. Remove problematic ARIA attributes that cause errors or are redundant
    this.removeAttributes(element, [
      // 'role',
      'aria-controls',
      // 'aria-labelledby',
      // 'aria-current',
      // 'aria-selected',
      // 'tabindex',
      'data-pc-name',
      'data-p-active',
      'data-p-disabled',
      'pc70',
    ]);

    // 2. Remove aria-controls if target doesn't exist in DOM
    const ariaControls = element.getAttribute('aria-controls');
    if (ariaControls && !document.getElementById(ariaControls)) {
      this.renderer.removeAttribute(element, 'aria-controls');
    }

    // 3. Remove aria-expanded if role does not support it
    const ariaExpanded = element.getAttribute('aria-expanded');
    if (ariaExpanded !== null) {
      const role = element.getAttribute('role') || '';
      const allowedRoles = ['button', 'link', 'combobox', 'textbox', 'menuitem'];
      if (!allowedRoles.includes(role)) {
        this.renderer.removeAttribute(element, 'aria-expanded');
      }
    }

    // 4. Fix PrimeNG datepicker input missing role combobox
    if (
      element.classList.contains('p-datepicker-input') &&
      !element.hasAttribute('role')
    ) {
      this.renderer.setAttribute(element, 'role', 'combobox');
    }

    // 5. Remove tabindex if aria-hidden=true to prevent focus on hidden elements
    if (
      element.getAttribute('aria-hidden') === 'true' &&
      element.hasAttribute('tabindex')
    ) {
      // this.renderer.removeAttribute(element, 'tabindex');
    }

    // 6. Remove all data-p-* attributes (PrimeNG data attrs)
    Array.from(element.attributes).forEach(attr => {
      if (attr.name.startsWith('data-p-')) {
        this.renderer.removeAttribute(element, attr.name);
      }
    });

    // 7. Fix roles on PrimeNG stepper elements for correct ARIA nesting

    
    // 8. Fix div with role="tab" wrapping interactive elements (invalid)
    if (tag === 'DIV' && element.getAttribute('role') === 'tab') {
      const hasFocusableChild = Array.from(element.children).some(child =>
        ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'A'].includes(child.tagName)
      );
      if (hasFocusableChild) {
        // Replace role=tab with presentation
        this.renderer.setAttribute(element, 'role', 'presentation');
      }
    }

    // 9. Remove role="tab" on p-button elements (buttons shouldn't have role tab)
    if (tag === 'P-BUTTON' && element.getAttribute('role') === 'tab') {
      this.renderer.removeAttribute(element, 'role');
    }

    // 10. Disable focus/tabindex on hidden elements and disable inputs/buttons
    const isHidden = this.isElementOrParentHidden(element);
    const focusableTags = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA', 'A'];
    if (isHidden && focusableTags.includes(tag)) {
      this.renderer.setAttribute(element, 'tabindex', '-1');
      if (['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(tag)) {
        this.renderer.setAttribute(element, 'disabled', 'true');
      }
    }

    // 11. Remove tabindex from <hr> elements
    if (tag === 'HR' && element.hasAttribute('tabindex')) {
      this.renderer.removeAttribute(element, 'tabindex');
    }

    if (element.getAttribute('role') === 'tabpanel') {
  const disallowedTags = ['HR'];
  Array.from(element.children).forEach(child => {
    if (disallowedTags.includes(child.tagName.toUpperCase())) {
      this.renderer.removeChild(element, child);
    }
  });
}
    // Recurse on children
    Array.from(element.children).forEach(child => {
      this.cleanElementRecursively(child as HTMLElement);
    });

    // 13. Remove invalid role on PrimeNG's p-stepper container
if (tag === 'P-STEPPER' && element.getAttribute('role') === 'tablist') {
  this.renderer.removeAttribute(element, 'role');
}

  }

  private removeAttributes(el: HTMLElement, attributes: string[]) {
    attributes.forEach(attr => {
      if (el.hasAttribute(attr)) {
        this.renderer.removeAttribute(el, attr);
      }
    });
  }

  private isElementOrParentHidden(el: HTMLElement): boolean {
    let current: HTMLElement | null = el;
    while (current) {
      if (
        current.getAttribute('aria-hidden') === 'true' ||
        current.hasAttribute('hidden') ||
        window.getComputedStyle(current).display === 'none'
      ) {
        return true;
      }
      current = current.parentElement;
    }
    return false;
  }
}
